import styled from "styled-components";

export const QrcodeStyle = styled.section`
    text-align: center;
    margin: .5rem 0;
    img {
        width: 2.5rem;
    }
`;
